import React, { useState } from "react";
import { Row, Col, Card, Button, Steps, Popover } from "antd";
import TextInput from "../../components/input/TextInput";
import "./Styles.css";
import { EMAIL_REGX } from "../../config/variables";
import { formatToNumber } from "../../config/utils";
import { useDispatch } from "react-redux";
import { AuthAction } from "../../store/actions";
import RMX from "../../assets/images/b-RMX-1.png";
import CustomModal from "../../components/modals/customModal";
const Register = ({ count, onChangeStep, userData }) => {
  const dispatch = useDispatch();
  const [continiueSignup, setContiniueSignup] = useState(false);
  const [contactInfo, setInfo] = useState({
    title: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    confirm_password: "",
  });
  const [errors, setErrors] = useState({
    first_nameError: "",
    last_nameError: "",
    emailError: "",
    phoneError: "",
    passwordError: "",
    confirm_passwordError: "",
  });

  const [loginInfo, setLoginInfo] = useState({
    email: "",
    password: "",
  });
  const [loginErrors, setLoginErrors] = useState({
    emailError: "",
    passwordError: "",
  });

  const onChangeContactInfo = (e) => {
    setInfo({
      ...contactInfo,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [`${e.target.name}Error`]: "",
    });
  };

  const onChangeLoginInfo = (e) => {
    setLoginInfo({
      ...loginInfo,
      [e.target.name]: e.target.value,
    });
    setLoginErrors({
      ...loginErrors,
      [`${e.target.name}Error`]: "",
    });
  };

  const onLogin = () => {
    let user_nameError = "";
    let passwordError = "";

    if (
      !loginInfo?.email.trim().length ||
      loginInfo?.password.trim().length < 8
    ) {
      if (!EMAIL_REGX.test(loginInfo.email)) {
        user_nameError = "Email is required.";
        setLoginErrors({
          ...loginErrors,
          emailError: user_nameError,
        });
      }
      if (!loginInfo?.password.trim().length) {
        passwordError = "Password is required.";
        setLoginErrors({
          ...loginErrors,
          emailError: user_nameError,
          passwordError,
        });
      }
      return;
    }
    // userData(contactInfo);
    // dispatch(
    //   AuthAction.SignIn({ ...loginInfo, isFromRegister: true }, () =>
    //     setContiniueSignup(false)
    //   )
    // );
    setContiniueSignup(false);
  };

  const onSubmit = () => {
    let first_nameError = "";
    let last_nameError = "";
    let phoneError = "";
    let emailError = "";
    let passwordError = "";
    let confirm_passwordError = "";
    if (
      !contactInfo?.first_name.trim().length ||
      !contactInfo?.last_name.trim().length ||
      !contactInfo?.phone.trim().length ||
      !EMAIL_REGX.test(contactInfo.email) ||
      !contactInfo?.password.trim().length ||
      !contactInfo?.confirm_password.trim().length ||
      contactInfo.password !== contactInfo.confirm_password ||
      contactInfo?.password.trim().length < 8
    ) {
      if (!contactInfo?.first_name.trim().length) {
        first_nameError = "First name is required.";
        setErrors({
          ...errors,
          first_nameError,
        });
      }
      if (!contactInfo?.last_name.trim().length) {
        last_nameError = "Last name is required.";
        setErrors({
          ...errors,
          first_nameError,
          last_nameError,
        });
      }
      if (!contactInfo?.phone.trim().length) {
        phoneError = "Phone number is required.";
        setErrors({
          ...errors,
          phoneError,
          first_nameError,
          last_nameError,
        });
      }
      if (!EMAIL_REGX.test(contactInfo.email)) {
        emailError = "Email is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
        });
      }
      if (!contactInfo?.password.trim().length) {
        passwordError = "Password is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
        });
      }
      if (contactInfo?.password && contactInfo?.password.trim().length < 8) {
        passwordError = "password should be at least 8 characters long. ";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
        });
      }
      if (!contactInfo?.confirm_password.trim().length) {
        confirm_passwordError = "Confirm password is required.";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,

          confirm_passwordError,
        });
      }

      if (contactInfo.password !== contactInfo.confirm_password) {
        confirm_passwordError = "mismatch password";
        setErrors({
          ...errors,
          emailError,
          phoneError,
          first_nameError,
          last_nameError,
          passwordError,
          confirm_passwordError,
        });
      }
      return;
    }
    userData(contactInfo);
    dispatch(AuthAction.validationReq(contactInfo, () => onChangeStep()));
  };
  console.log("loginError==>", loginErrors);
  const {
    first_nameError,
    last_nameError,
    phoneError,
    emailError,
    passwordError,
    confirm_passwordError,
  } = errors;
  const { Step } = Steps;
  const customDot = (dot, { status, index }) => (
    <Popover
      content={
        <span>
          step {index} status: {status}
        </span>
      }
    >
      {dot}
    </Popover>
  );

  return (
    <Row justify="center">
      <Col xs={24} sm={24} md={24} xl={24} lg={24}>
        <Card>
          <Row>
            <Col
              xl={24}
              lg={24}
              xs={24}
              sm={24}
              md={24}
              style={{
                padding: "15px",
                justifyContent: "start",
                display: "flex",
                marginTop: "20px",
              }}
            >
              <img
                src={RMX}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  backgroundRepeat: "no-repeat",
                  top: "-20px",
                  paddingLeft: "50px",
                }}
              />
            </Col>
          </Row>
          <Steps current={count} progressDot={customDot}>
            <Step title="Register" />
            <Step title="Create Profile" />
            <Step title="Add your plant" />
            <Step title="Personlize" />
            <Step title="Build Catalog" />
            <Step title="Subscription" />
          </Steps>
          <div
            style={{
              width: "90%",
              margin: "auto",
              // boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
              border: "solid #eaeaea 1px",
              padding: "1rem",
              marginTop: "20px",
            }}
          >
            <Col className="login-card">
              <h2 className="text-left">Contact Information</h2>
            </Col>
            <Row justify="center">
              <Col
                xs={24}
                sm={24}
                md={24}
                xl={12}
                lg={12}
                className="cardpadding"
              >
                <Row>
                  <Col span={24}>
                    <TextInput
                      label={"Title"}
                      name="title"
                      onChange={onChangeContactInfo}
                      value={contactInfo.title}
                    />
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"First Name"}
                      required
                      name="first_name"
                      onChange={onChangeContactInfo}
                      value={contactInfo.first_name}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {first_nameError && first_nameError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Last Name"}
                      required
                      name="last_name"
                      onChange={onChangeContactInfo}
                      value={contactInfo.last_name}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {last_nameError && last_nameError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Phone Number"}
                      required
                      name="phone"
                      onChange={onChangeContactInfo}
                      value={formatToNumber(contactInfo.phone)}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {phoneError && phoneError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>

              <Col
                xs={24}
                sm={24}
                md={24}
                xl={12}
                lg={12}
                className="cardpadding logincardStyling"
              >
                <Col className="login-card">
                  <h2 className="text-left">Login Credentials</h2>
                </Col>
                <Row>
                  <Col span={24}>
                    <TextInput
                      label={"Email Address"}
                      required
                      name="email"
                      onChange={onChangeContactInfo}
                      value={contactInfo.email}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {emailError && emailError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Password"}
                      required
                      type="password"
                      name="password"
                      onChange={onChangeContactInfo}
                      value={contactInfo.password}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        <span className="danger-color text-right">
                          {passwordError && passwordError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <TextInput
                      label={"Confirm Password"}
                      required
                      type="password"
                      name="confirm_password"
                      onChange={onChangeContactInfo}
                      value={contactInfo.confirm_password}
                    />
                    <Row justify="end">
                      <Col span={24} className="text-right">
                        {" "}
                        <span className="danger-color text-right">
                          {confirm_passwordError && confirm_passwordError}
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <Col xs={23} sm={20} md={24} xl={24} lg={24}>
            <h3
              style={{
                color: "#ff9800",
                marginTop: "20px",
                alignItems: "center",
              }}
            >
              Already started sign-up process?
              <span
                className="pointer-cursor"
                style={{ fontWeight: "600", marginLeft: "5px" }}
                onClick={() => setContiniueSignup(true)}
              >
                Continue from here
              </span>
            </h3>
          </Col>
          <Row
            justify="end"
            style={{ marginBottom: "20px", marginTop: "10px" }}
          >
            <Col xs={24} sm={24} md={10} lg={8} xl={6}>
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "50%",
                }}
                onClick={() => onSubmit()}
              >
                CREATE PROFILE
              </Button>
            </Col>
          </Row>
        </Card>
        <CustomModal
          visible={continiueSignup}
          onCancelModal={() => setContiniueSignup(false)}
          closable={false}
          width={450}
          footer={null}
        >
          <Col xl={24}>
            <h5 className="text-center ">Login Credentials</h5>
          </Col>
          <Col xl={24}>
            <h5
              className="text-center "
              style={{ fontSize: "1rem", color: "#9e9e9e" }}
            >
              Already Registered? Please Login Below.
            </h5>
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={22}>
                <TextInput
                  label={"Username"}
                  required
                  type="username"
                  name="email"
                  onChange={onChangeLoginInfo}
                  value={loginInfo.email}
                />
                <Row>
                  <Col span={24}>
                    <p className="danger-color">
                      {loginErrors.emailError && loginErrors.emailError}
                    </p>
                  </Col>
                </Row>
                <TextInput
                  label={"Password"}
                  required
                  type="password"
                  name="password"
                  onChange={onChangeLoginInfo}
                  value={loginInfo.password}
                />
                <Row>
                  <Col span={24}>
                    <p className="danger-color">
                      {loginErrors.passwordError && loginErrors.passwordError}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row justify="center">
              <Col span={10} style={{ paddingBottom: "2rem" }}>
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "white",
                    width: "100%",
                    border: "none",
                  }}
                  onClick={() => onLogin()}
                >
                  LOGIN
                </Button>
              </Col>
            </Row>
          </Col>
        </CustomModal>
      </Col>
    </Row>
  );
};

export default Register;
